import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=5d778873&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d778873')) {
      api.createRecord('5d778873', component.options)
    } else {
      api.reload('5d778873', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=5d778873&", function () {
      api.rerender('5d778873', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-84M1dJx5PSa0X/JS/comp/ImgFallback.vue"
export default component.exports